import React, { useState } from 'react';
import { Gamepad2, Trophy, Star } from 'lucide-react';
import AdminGamesSettings from './AdminGames';
import AdminSpecialMatches from './AdminSpecialMatches';
import AdminTrophies from './AdminTrophies';

const TABS = [
  { key: 'games', label: 'Giochi', icon: Gamepad2 },
  { key: 'matches', label: 'Partite Speciali', icon: Trophy },
  { key: 'trophies', label: 'Trofei', icon: Star },
];

export default function AdminGamesHub() {
  const [tab, setTab] = useState('games');

  return (
    <div data-testid="admin-games-hub">
      {/* Tab navigation */}
      <div className="px-6 md:px-8 lg:px-10 pt-6">
        <div className="flex items-center gap-1 bg-slate-100 rounded-xl p-1 w-fit">
          {TABS.map(t => (
            <button key={t.key} onClick={() => setTab(t.key)} data-testid={`games-tab-${t.key}`}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all ${
                tab === t.key ? 'bg-white text-[#D44E20] shadow-sm' : 'text-slate-500 hover:text-slate-700'
              }`}>
              <t.icon size={15} />
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      {tab === 'games' && <AdminGamesSettings />}
      {tab === 'matches' && <AdminSpecialMatches />}
      {tab === 'trophies' && <AdminTrophies />}
    </div>
  );
}
